/**
 * ProgramCta
 *
 * Used on the program detail block. Will make an AJAX call to the backend through
 * the Varnish tunnel and return a CTA based on the country of the user.
 *
 * @author Tim
 */
export default class ProgramCta {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.$btn = $wrapper.querySelector('[data-program-cta-btn]');

        this.updateCta = this.updateCta.bind(this);
        this.fetchCta = this.fetchCta.bind(this);

        this.updateCta();
    }

    async updateCta() {
        const result = await this.fetchCta();

        if (result.href && result.title && result.label) {
            this.$btn.href = result.href;
            this.$btn.title = result.title;
            this.$btn.innerHTML = result.label;
            this.$wrapper.classList.toggle('d-none');
        }
    }

    async fetchCta() {
        try {
            let url =  placeholders.baseUri ?
                placeholders.baseUri + '/ajax-data/program-cta' :
                '/ajax-data/program-cta';

            url += '?id=' + this.$wrapper.dataset.programId;

            const request = await fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            );

            return await request.json();
        } catch (e) {
            console.log(e);
        }
    }
}
